var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlagHalal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74118 1.64706L7.41176 0H0V14H1.64706V8.23529H6.25882L6.58824 9.88235H12.3529V1.64706H7.74118Z",
    fill: "#0A8F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagHalal);
export default __webpack_public_path__ + "static/media/icon-flag-halal.8cbff320b29fec563b9b590aed0b179b.svg";
export { ForwardRef as ReactComponent };